import girlPearlEarringPNG from '~/assets/images/art/girl-pearl-earring.png'
import girlPearlEarringWEBP from '~/assets/images/art/girl-pearl-earring.webp'
import { ImageChoiceQuiz } from '~/shared/components/ImageChoiceQuiz'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  { key: 'vermeer', i18nKey: 'vermeer' },
  { key: 'rembrandt', i18nKey: 'rembrandt' },
  { key: 'vanGogh', i18nKey: 'vanGogh' },
  { key: 'notSure', i18nKey: 'notSure' },
] as const

const GirlPearlEarring = (props: TPageProps) => (
  <ImageChoiceQuiz
    {...props}
    ns="art"
    question="Who painted this?"
    questionI18nKey="onboarding.artQuiz.girlPearlEarring.question"
    optionsI18nKeyPrefix="onboarding.artQuiz.girlPearlEarring.options"
    options={OPTIONS}
    image={{
      png: girlPearlEarringPNG,
      webp: girlPearlEarringWEBP,
      alt: 'Girl with a Pearl Earring',
    }}
  />
)

export default GirlPearlEarring
